<template>
  <b-container fluid>
     <b-row>
       <b-col cols="12">
         <h3>{{ $t('LNG_MAINVIEW_TITLE', this.lang) }}</h3>
       </b-col>
     </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
// const constDateFormat = 'DD.MM.YYYY'
export default {
  name: 'mainview',
  components: {
  },
  data () {
    return {
    }
  },
  mounted: function () {
    moment.locale('fr-ch')
    this.$parent.spinner = false
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ]),
    adminLevel () {
      return this.$store.getters.adminLevel
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
</style>



// WEBPACK FOOTER //
// myAccount.vue?06965176